// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DepartmentSelectorMenu-module__departmentMenu__RPZsp {
  background-color: #303048;
  min-height: 390px !important;
  max-height: 450px !important;
}
.DepartmentSelectorMenu-module__departmentMenu__RPZsp .ant-menu-light {
  background: #303048;
  border-radius: 2px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
  width: 240px !important;
}
.DepartmentSelectorMenu-module__departmentMenu__RPZsp .ant-menu-title-content {
  color: #c2c2d0;
}
.DepartmentSelectorMenu-module__header__P05Hv {
  padding: 10px 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.DepartmentSelectorMenu-module__header__P05Hv .ant-avatar {
  margin-right: 10px;
}
.DepartmentSelectorMenu-module__departmentSearch__St0Tv {
  padding: 0 12px;
  height: 32px;
  width: 240px !important;
  background-color: transparent !important;
  outline: none;
  border: none;
}
.DepartmentSelectorMenu-module__departmentSearch__St0Tv .ant-input,
.DepartmentSelectorMenu-module__departmentSearch__St0Tv .ant-input-outlined {
  background-color: transparent;
  color: #c2c2d0 !important;
}
.DepartmentSelectorMenu-module__departmentSearch__St0Tv .ant-input-clear-icon svg path {
  fill: #c2c2d0;
}
.DepartmentSelectorMenu-module__menuItem__Pb7fN {
  max-height: 28px;
  padding: 0 12px 0 7px;
  margin: 2px 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  border-radius: 0 !important;
  width: 100.6% !important;
  cursor: pointer;
}
.DepartmentSelectorMenu-module__menuItem__Pb7fN .ant-menu-title-content {
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
}
.DepartmentSelectorMenu-module__menuContainer__a4Y_Z {
  min-height: 360px !important;
  max-height: 450px !important;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.DepartmentSelectorMenu-module__menuContainer__a4Y_Z .ant-menu-item:hover {
  background-color: #595973 !important;
  outline: none;
  color: #e5e5eb;
}
.DepartmentSelectorMenu-module__topMenu__nUN2a {
  padding-top: 8px;
  width: 100%;
  height: 100%;
  height: 343px;
}
.DepartmentSelectorMenu-module__bottomMenu__mdvau {
  width: 100%;
}
.DepartmentSelectorMenu-module__activeItem__dAo0P {
  background: #595973;
  color: #e5e5eb;
}
.DepartmentSelectorMenu-module__departmentList__hwbGl {
  min-height: 100px !important;
}
.DepartmentSelectorMenu-module__menuDivider__WatbH {
  margin: 2px 0;
  border-color: #797993;
}
`, "",{"version":3,"sources":["webpack://./src/components/department/DepartmentSelectorMenu.module.less"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,4BAAA;EACA,4BAAA;AACF;AAJA;EAKI,mBAAA;EACA,kBAAA;EACA,+CAAA;EACA,uBAAA;AAEJ;AAVA;EAWI,cAAA;AAEJ;AAEA;EACE,kBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;AAAF;AAJA;EAMI,kBAAA;AACJ;AAGA;EACE,eAAA;EACA,YAAA;EACA,uBAAA;EACA,wCAAA;EACA,aAAA;EACA,YAAA;AADF;AALA;;EAUI,6BAAA;EACA,yBAAA;AADJ;AAVA;EAgBQ,aAAA;AAHR;AASA;EACE,gBAAA;EACA,qBAAA;EACA,wBAAA;EACA,wBAAA;EACA,8BAAA;EACA,sCAAA;EACA,2BAAA;EACA,wBAAA;EACA,eAAA;AAPF;AAFA;EAYI,eAAA;EACA,uBAAA;EACA,gBAAA;AAPJ;AAWA;EACE,4BAAA;EACA,4BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;AATF;AAGA;EAQI,oCAAA;EACA,aAAA;EACA,cAAA;AARJ;AAYA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAVF;AAaA;EACE,WAAA;AAXF;AAcA;EACE,mBAAA;EACA,cAAA;AAZF;AAeA;EACE,4BAAA;AAbF;AAgBA;EACE,aAAA;EACA,qBAAA;AAdF","sourcesContent":[".departmentMenu {\n  background-color: #303048;\n  min-height: 390px !important;\n  max-height: 450px !important;\n  :global(.ant-menu-light) {\n    background: #303048;\n    border-radius: 2px;\n    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);\n    width: 240px !important;\n  }\n  :global(.ant-menu-title-content) {\n    color: #c2c2d0;\n  }\n}\n\n.header {\n  padding: 10px 12px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  :global(.ant-avatar) {\n    margin-right: 10px;\n  }\n}\n\n.departmentSearch {\n  padding: 0 12px;\n  height: 32px;\n  width: 240px !important;\n  background-color: transparent !important;\n  outline: none;\n  border: none;\n\n  :global(.ant-input),\n  :global(.ant-input-outlined) {\n    background-color: transparent;\n    color: #c2c2d0 !important;\n  }\n  :global(.ant-input-clear-icon) {\n    svg {\n      path {\n        fill: #c2c2d0;\n      }\n    }\n  }\n}\n\n.menuItem {\n  max-height: 28px;\n  padding: 0 12px 0 7px;\n  margin: 2px 0 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: flex-start !important;\n  border-radius: 0 !important;\n  width: 100.6% !important;\n  cursor: pointer;\n\n  :global(.ant-menu-title-content) {\n    max-width: 100%;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n}\n\n.menuContainer {\n  min-height: 360px !important;\n  max-height: 450px !important;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  :global(.ant-menu-item:hover) {\n    background-color: #595973 !important;\n    outline: none;\n    color: #e5e5eb;\n  }\n}\n\n.topMenu {\n  padding-top: 8px;\n  width: 100%;\n  height: 100%;\n  height: 343px;\n}\n\n.bottomMenu {\n  width: 100%;\n}\n\n.activeItem {\n  background: #595973;\n  color: #e5e5eb;\n}\n\n.departmentList {\n  min-height: 100px !important;\n}\n\n.menuDivider {\n  margin: 2px 0;\n  border-color: #797993;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"departmentMenu": `DepartmentSelectorMenu-module__departmentMenu__RPZsp`,
	"header": `DepartmentSelectorMenu-module__header__P05Hv`,
	"departmentSearch": `DepartmentSelectorMenu-module__departmentSearch__St0Tv`,
	"menuItem": `DepartmentSelectorMenu-module__menuItem__Pb7fN`,
	"menuContainer": `DepartmentSelectorMenu-module__menuContainer__a4Y_Z`,
	"topMenu": `DepartmentSelectorMenu-module__topMenu__nUN2a`,
	"bottomMenu": `DepartmentSelectorMenu-module__bottomMenu__mdvau`,
	"activeItem": `DepartmentSelectorMenu-module__activeItem__dAo0P`,
	"departmentList": `DepartmentSelectorMenu-module__departmentList__hwbGl`,
	"menuDivider": `DepartmentSelectorMenu-module__menuDivider__WatbH`
};
export default ___CSS_LOADER_EXPORT___;
